<template>
    <div>
        <b-dropdown id="dropdown-1" text="Opções" class="m-md-2">
        <b-dropdown-item @click="handleClick(option)" v-for="option in options" :key="option.label">{{
            option.label }}</b-dropdown-item>
    </b-dropdown>
    </div>
</template>

<script>

export default {
  name: 'DropDownButton',
  props: {
    options: {
      type: Array,
      required: true
    }
  },
  methods: {
    handleClick (option) {
      this.$emit('item-clicked', option)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/parametros_atendimento/mensagensautomaticas/components/dropdown/DropDownMensagensAutomaticas.vue